document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const applyGmcContentFallback = () => {
    document.querySelectorAll('.site-footer').forEach((footer) => {
      if (!/13599166764|Hong Kong|KWUN TONG/i.test(footer.textContent || '')) return;

      const contact = footer.querySelector('.footer__contact');
      if (contact) {
        contact.innerHTML = [
          '<strong>Kontakt</strong><br>',
          'Golden Bridge GmbH<br>',
          'Vertreten durch: Shien Chen<br>',
          'E-Mail: <a href="mailto:service@sikainihome.de">service@sikainihome.de</a><br>',
          'USt-IdNr.: DE333116578<br>',
          'Handelsregister: HRB 743643<br>',
          '<span>R&uuml;cksendeadresse: LDM GmbH-4BS-BY134, Edekastra&szlig;e 9, 97228 Rottendorf, Bayern, Deutschland</span>',
        ].join('');
      }

      footer.querySelectorAll('a[href="/pages/support-faq"]').forEach((link) => {
        link.href = '/pages/hilfe-faq';
      });

      const legalColumn = Array.from(footer.querySelectorAll('div')).find((column) => /Rechtliches/i.test(column.textContent || ''));
      const legalList = legalColumn?.querySelector('.footer__links');
      if (legalList && !legalList.querySelector('a[href="/pages/versand-lieferung"]')) {
        const item = document.createElement('li');
        item.innerHTML = '<a href="/pages/versand-lieferung">Versand &amp; Lieferung</a>';
        legalList.appendChild(item);
      }
    });

    document.querySelectorAll('.product-tax-note').forEach((note) => {
      if (/Versand im Checkout/i.test(note.textContent || '')) {
        note.innerHTML = 'inkl. MwSt. &middot; kostenloser Versand innerhalb Deutschlands.';
      }
    });

    document.querySelectorAll('.product-price s, .product-card__price s').forEach((strikePrice) => {
      strikePrice.remove();
    });

    document.querySelectorAll('.product-card__price .sale-price').forEach((price) => {
      price.classList.remove('sale-price');
    });

    const productLinkMap = {
      '/products/kinderbett-hausbett-90-x-200-cm-holzbett-mit-tafel-und-2-schubladen-massivholz-mit-zaun-und-lattenrost-weiss-ohne-matratze': '/products/kinderbett-hausbett-90-x-200-cm-holzbett-mit-tafel-und-2-schubladen-massivholz-mit-zaun-und-lattenrost-weiss-ohne-matratze-gmc',
      '/products/rutschbett-mit-rechtwinkliger-leiter-hausbett-mit-dach-kinderbett-spielturmbett-mit-fallschutz-und-gitter-rahmen-aus-massiver-kiefer-weiss-200x90cm-100x90cm': '/products/rutschbett-mit-rechtwinkliger-leiter-hausbett-mit-dach-kinderbett-spielturmbett-mit-fallschutz-und-gitter-rahmen-aus-massiver-kiefer-weiss-200x90cm-100x90cm-gmc',
      '/products/hausbett-kinderbett-jugendbett-200x90-mit-rausfallschutz-vielseitiges-holz-kinderbett-fur-jungen-madchen-wei-schubladen-massivholz-kinder-bett-mit-rausfallschutz-fenster-und-lattenrost-weiss': '/products/hausbett-kinderbett-jugendbett-200x90-mit-rausfallschutz-vielseitiges-holz-kinderbett-fur-jungen-madchen-wei-schubladen-massivholz-kinder-bett-mit-rausfallschutz-fenster-und-lattenrost-weiss-gmc',
      '/products/etagenbett-bett-mit-ecktreppe-hausbett-kinderbett-mit-fallschutz-und-gitter-mit-fenster-rahmen-aus-kiefer-weiss-200x90cm': '/products/etagenbett-bett-mit-ecktreppe-hausbett-kinderbett-mit-fallschutz-und-gitter-mit-fenster-rahmen-aus-kiefer-weiss-200x90cm-gmc',
    };

    document.querySelectorAll('a[href^="/products/"]').forEach((link) => {
      const cleanHref = link.getAttribute('href')?.split('?')[0];
      if (cleanHref && productLinkMap[cleanHref]) {
        link.href = productLinkMap[cleanHref];
      }
    });
  };

  applyGmcContentFallback();

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
    const prev = slider.querySelector('[data-hero-prev]');
    const next = slider.querySelector('[data-hero-next]');
    let touchStartX = 0;
    let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;

    const show = (index) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === active));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
    };

    const restart = () => {
      window.clearInterval(timer);
      if (slides.length > 1) {
        timer = window.setInterval(() => show(active + 1), 5600);
      }
    };

    prev?.addEventListener('click', () => {
      show(active - 1);
      restart();
    });

    next?.addEventListener('click', () => {
      show(active + 1);
      restart();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        show(index);
        restart();
      });
    });

    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', restart);
    slider.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX || 0;
      window.clearInterval(timer);
    }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const delta = touchEndX - touchStartX;
      if (Math.abs(delta) > 42) {
        show(active + (delta < 0 ? 1 : -1));
      }
      restart();
    }, { passive: true });
    restart();
  });

  document.querySelectorAll('.category-slider-shell').forEach((shell) => {
    const scroller = shell.querySelector('[data-scroll-slider]');
    const prev = shell.querySelector('[data-scroll-prev]');
    const next = shell.querySelector('[data-scroll-next]');
    let autoTimer;
    let cardStep = 0;
    let loopStart = 0;
    let loopEnd = 0;
    let loopWidth = 0;
    let isAdjustingLoop = false;

    const cards = scroller ? Array.from(scroller.querySelectorAll('.slider-category-card')) : [];

    const makeClone = (card) => {
      const clone = card.cloneNode(true);
      clone.classList.add('is-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((node) => {
        node.tabIndex = -1;
      });
      return clone;
    };

    const measureLoop = () => {
      if (!scroller || cards.length < 2) return;

      const firstReal = cards[0];
      const firstAfterClone = scroller.querySelector('[data-loop-after="true"]');
      const secondReal = cards[1];

      loopStart = firstReal.offsetLeft;
      loopEnd = firstAfterClone ? firstAfterClone.offsetLeft : 0;
      loopWidth = loopEnd - loopStart;
      cardStep = secondReal ? secondReal.offsetLeft - firstReal.offsetLeft : firstReal.getBoundingClientRect().width + 18;
    };

    const jumpTo = (left) => {
      if (!scroller) return;
      isAdjustingLoop = true;
      scroller.style.scrollBehavior = 'auto';
      scroller.scrollLeft = left;
      window.requestAnimationFrame(() => {
        scroller.style.scrollBehavior = '';
        isAdjustingLoop = false;
      });
    };

    const keepLoopInRange = () => {
      if (!scroller || !loopWidth || isAdjustingLoop) return;

      if (scroller.scrollLeft >= loopEnd) {
        jumpTo(scroller.scrollLeft - loopWidth);
      } else if (scroller.scrollLeft < loopStart) {
        jumpTo(scroller.scrollLeft + loopWidth);
      }
    };

    const setupInfiniteLoop = () => {
      if (!scroller || cards.length < 2 || scroller.dataset.loopReady === 'true') return;

      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();

      cards.forEach((card, index) => {
        const beforeClone = makeClone(card);
        beforeClone.dataset.loopBefore = 'true';
        before.appendChild(beforeClone);

        const afterClone = makeClone(card);
        if (index === 0) {
          afterClone.dataset.loopAfter = 'true';
        }
        after.appendChild(afterClone);
      });

      scroller.prepend(before);
      scroller.append(after);
      scroller.dataset.loopReady = 'true';

      window.requestAnimationFrame(() => {
        measureLoop();
        jumpTo(loopStart);
      });
    };

    const scrollByCard = (direction) => {
      if (!scroller) return;
      keepLoopInRange();
      const amount = cardStep || scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };

    const restart = () => {
      window.clearInterval(autoTimer);
      if (scroller?.dataset.galleryAutoplay === 'true') {
        autoTimer = window.setInterval(() => {
          scrollByCard(1);
        }, 3600);
      }
    };

    prev?.addEventListener('click', () => {
      scrollByCard(-1);
      restart();
    });

    next?.addEventListener('click', () => {
      scrollByCard(1);
      restart();
    });

    shell.addEventListener('mouseenter', () => window.clearInterval(autoTimer));
    shell.addEventListener('mouseleave', restart);
    scroller?.addEventListener('scroll', () => window.requestAnimationFrame(keepLoopInRange), { passive: true });
    window.addEventListener('resize', () => {
      measureLoop();
      keepLoopInRange();
    });
    setupInfiniteLoop();
    restart();
  });

  document.querySelectorAll('[data-pillow-finder]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const routesScript = form.querySelector('[data-finder-routes]');
      const note = form.querySelector('[data-finder-note]');
      let routes = {};

      try {
        routes = JSON.parse(routesScript.textContent);
      } catch (error) {
        routes = {};
      }

      const user = data.get('user');
      const support = data.get('support');
      const target = user === 'child' || user === 'gift' ? routes[user] : routes[support] || routes.adult;

      if (note) {
        note.textContent = 'Wir leiten Sie zu einer passenden SIKAINI Kollektion weiter...';
      }

      window.location.href = target || '/collections/all';
    });
  });

  document.querySelectorAll('[data-article-content]').forEach((content) => {
    const layout = content.closest('.article-layout');
    const toc = layout ? layout.querySelector('[data-article-toc]') : null;
    const headings = content.querySelectorAll('h2, h3');

    if (!toc || headings.length === 0) {
      if (toc) toc.innerHTML = '<p>Noch keine Abschnitte.</p>';
      return;
    }

    const list = document.createElement('ol');

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `article-section-${index + 1}`;
      }

      const item = document.createElement('li');
      item.className = heading.tagName.toLowerCase() === 'h3' ? 'toc-subitem' : '';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.replaceChildren(list);
  });

  const setupRoomVisualizer = (visualizer) => {
    if (visualizer.dataset.visualizerReady === 'true') return;
    visualizer.dataset.visualizerReady = 'true';

    const upload = visualizer.querySelector('[data-room-upload]');
    const preview = visualizer.querySelector('[data-room-preview]');
    const empty = visualizer.querySelector('[data-room-empty]');
    const stage = visualizer.querySelector('[data-room-stage]');
    const layer = visualizer.querySelector('[data-room-material-layer]');
    const choices = Array.from(visualizer.querySelectorAll('[data-product-choice]'));
    const scale = visualizer.querySelector('[data-room-scale]');
    const rotate = visualizer.querySelector('[data-room-rotate]');
    const opacity = visualizer.querySelector('[data-room-opacity]');
    const reset = visualizer.querySelector('[data-room-reset]');
    const selectedTitle = visualizer.querySelector('[data-room-selected-title]');
    const list = visualizer.querySelector('[data-room-list]');
    const duplicate = visualizer.querySelector('[data-room-duplicate]');
    const flip = visualizer.querySelector('[data-room-flip]');
    const front = visualizer.querySelector('[data-room-front]');
    const back = visualizer.querySelector('[data-room-back]');
    const remove = visualizer.querySelector('[data-room-delete]');
    let selected = null;
    let isDragging = false;
    let dragOffset = { x: 0, y: 0 };
    let zIndex = 5;

    const materials = () => Array.from(layer?.querySelectorAll('[data-room-material]') || []);

    const getState = (item) => ({
      x: Number(item.dataset.x || 52),
      y: Number(item.dataset.y || 58),
      scale: Number(item.dataset.scale || 62),
      rotate: Number(item.dataset.rotate || 0),
      opacity: Number(item.dataset.opacity || 100),
      flip: item.dataset.flip === 'true',
    });

    const setState = (item, nextState) => {
      Object.entries(nextState).forEach(([key, value]) => {
        item.dataset[key] = String(value);
      });
    };

    const renderItem = (item) => {
      const state = getState(item);
      item.style.left = `${state.x}%`;
      item.style.top = `${state.y}%`;
      item.style.width = `${state.scale}%`;
      item.style.opacity = `${state.opacity / 100}`;
      item.style.transform = `translate(-50%, -50%) rotate(${state.rotate}deg) scaleX(${state.flip ? -1 : 1})`;
    };

    const syncControls = () => {
      if (!selected) {
        if (selectedTitle) selectedTitle.textContent = 'Noch kein Block';
        return;
      }
      const state = getState(selected);
      if (selectedTitle) selectedTitle.textContent = selected.dataset.title || 'Materialblock';
      if (scale) scale.value = state.scale;
      if (rotate) rotate.value = state.rotate;
      if (opacity) opacity.value = state.opacity;
    };

    const renderList = () => {
      if (!list) return;
      const items = materials();
      if (!items.length) {
        list.innerHTML = '<li>Noch keine Produkte hinzugef&uuml;gt.</li>';
        return;
      }

      const counts = items.reduce((acc, item) => {
        const title = item.dataset.title || 'Materialblock';
        acc[title] = (acc[title] || 0) + 1;
        return acc;
      }, {});

      list.replaceChildren(...Object.entries(counts).map(([title, count]) => {
        const li = document.createElement('li');
        li.textContent = `${count} \u00d7 ${title}`;
        return li;
      }));
    };

    const selectItem = (item) => {
      materials().forEach((material) => material.classList.toggle('is-selected', material === item));
      selected = item;
      syncControls();
    };

    const getStagePoint = (event) => {
      const rect = stage.getBoundingClientRect();
      const pointer = event.touches ? event.touches[0] : event;
      return {
        x: ((pointer.clientX - rect.left) / rect.width) * 100,
        y: ((pointer.clientY - rect.top) / rect.height) * 100,
      };
    };

    upload?.addEventListener('change', () => {
      const file = upload.files?.[0];
      if (!file || !preview) return;

      preview.src = URL.createObjectURL(file);
      preview.classList.add('is-visible');
      empty?.classList.add('is-hidden');
    });

    const addMaterial = ({ image, title, x = 52, y = 58, scaleValue = 62, rotateValue = 0, opacityValue = 100, flipValue = false }) => {
      if (!image || !layer) return;
      const item = document.createElement('img');
      item.className = 'visualizer-material';
      item.dataset.roomMaterial = 'true';
      item.dataset.title = title || 'Materialblock';
      item.dataset.x = String(x);
      item.dataset.y = String(y);
      item.dataset.scale = String(scaleValue);
      item.dataset.rotate = String(rotateValue);
      item.dataset.opacity = String(opacityValue);
      item.dataset.flip = String(flipValue);
      item.src = image;
      item.alt = title || '';
      item.draggable = false;
      item.style.zIndex = String(zIndex++);
      layer.appendChild(item);
      renderItem(item);
      selectItem(item);
      renderList();
    };

    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        addMaterial({ image: choice.dataset.productImage, title: choice.dataset.productTitle });
        choices.forEach((item) => item.classList.toggle('is-active', item === choice));
      });
    });

    layer?.addEventListener('pointerdown', (event) => {
      const item = event.target.closest('[data-room-material]');
      if (!item) return;
      event.preventDefault();
      selectItem(item);
      const point = getStagePoint(event);
      isDragging = true;
      const state = getState(item);
      dragOffset = { x: point.x - state.x, y: point.y - state.y };
      item.setPointerCapture(event.pointerId);
      item.classList.add('is-dragging');
    });

    layer?.addEventListener('pointermove', (event) => {
      if (!isDragging || !selected) return;
      const point = getStagePoint(event);
      setState(selected, {
        ...getState(selected),
        x: Math.min(92, Math.max(8, point.x - dragOffset.x)),
        y: Math.min(92, Math.max(8, point.y - dragOffset.y)),
      });
      renderItem(selected);
    });

    layer?.addEventListener('pointerup', () => {
      isDragging = false;
      materials().forEach((item) => item.classList.remove('is-dragging'));
    });

    const updateSelectedFromControls = () => {
      if (!selected) return;
      setState(selected, {
        ...getState(selected),
        scale: scale ? Number(scale.value) : 62,
        rotate: rotate ? Number(rotate.value) : 0,
        opacity: opacity ? Number(opacity.value) : 100,
      });
      renderItem(selected);
    };

    scale?.addEventListener('input', updateSelectedFromControls);
    rotate?.addEventListener('input', updateSelectedFromControls);
    opacity?.addEventListener('input', updateSelectedFromControls);

    reset?.addEventListener('click', () => {
      if (!selected) return;
      setState(selected, { ...getState(selected), x: 52, y: 58, scale: 62, rotate: 0, opacity: 100, flip: false });
      renderItem(selected);
      syncControls();
    });

    duplicate?.addEventListener('click', () => {
      if (!selected) return;
      const state = getState(selected);
      addMaterial({
        image: selected.src,
        title: selected.dataset.title,
        x: Math.min(92, state.x + 4),
        y: Math.min(92, state.y + 4),
        scaleValue: state.scale,
        rotateValue: state.rotate,
        opacityValue: state.opacity,
        flipValue: state.flip,
      });
    });

    flip?.addEventListener('click', () => {
      if (!selected) return;
      setState(selected, { ...getState(selected), flip: !getState(selected).flip });
      renderItem(selected);
    });

    front?.addEventListener('click', () => {
      if (!selected) return;
      selected.style.zIndex = String(zIndex++);
    });

    back?.addEventListener('click', () => {
      if (!selected) return;
      selected.style.zIndex = '4';
    });

    remove?.addEventListener('click', () => {
      if (!selected) return;
      const next = selected.previousElementSibling || selected.nextElementSibling;
      selected.remove();
      selected = next?.matches?.('[data-room-material]') ? next : null;
      if (selected) selectItem(selected);
      syncControls();
      renderList();
    });

    const firstChoice = choices[0];
    if (firstChoice?.dataset.productImage) {
      addMaterial({ image: firstChoice.dataset.productImage, title: firstChoice.dataset.productTitle });
      firstChoice.classList.add('is-active');
    }
  };

  const visualizers = document.querySelectorAll('[data-room-visualizer]');

  if ('IntersectionObserver' in window) {
    const visualizerObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        setupRoomVisualizer(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '180px 0px' });

    visualizers.forEach((visualizer) => visualizerObserver.observe(visualizer));
  } else {
    visualizers.forEach(setupRoomVisualizer);
  }

  document.querySelectorAll('[data-collection-page]').forEach((page) => {
    const grid = page.querySelector('[data-product-grid]');
    const cards = Array.from(page.querySelectorAll('[data-product-card]'));
    const count = page.querySelector('[data-product-count]');
    const activeWrap = page.querySelector('[data-active-filters]');
    const activeList = page.querySelector('[data-active-filter-list]');
    const empty = page.querySelector('[data-filter-empty]');
    const pagination = page.querySelector('[data-pagination]');
    const drawer = page.querySelector('[data-filter-drawer]');
    const openDrawer = page.querySelector('[data-filter-drawer-open]');
    const closeDrawerButtons = page.querySelectorAll('[data-filter-drawer-close]');
    const optionButtons = Array.from(page.querySelectorAll('[data-filter-option]'));
    const presetButtons = Array.from(page.querySelectorAll('[data-filter-preset]'));
    const clearPresetButtons = Array.from(page.querySelectorAll('[data-filter-clear]'));
    const selected = new Map();

    const normalize = (value) => (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

    const optionId = (button) => `${button.dataset.filterKey}:${button.dataset.filterValue}`;

    const getOptionMeta = (button) => ({
      id: optionId(button),
      key: button.dataset.filterKey,
      value: button.dataset.filterValue,
      label: button.dataset.filterLabel || button.textContent.trim(),
      terms: (button.dataset.filterTerms || button.textContent)
        .split(',')
        .map((term) => normalize(term.trim()))
        .filter(Boolean),
      priceMin: button.dataset.priceMin ? Number(button.dataset.priceMin) : null,
      priceMax: button.dataset.priceMax ? Number(button.dataset.priceMax) : null,
    });

    const syncButtons = () => {
      optionButtons.forEach((button) => {
        const isActive = selected.has(optionId(button));
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const selectedByKey = () => {
      const groups = new Map();
      selected.forEach((meta) => {
        if (!groups.has(meta.key)) groups.set(meta.key, []);
        groups.get(meta.key).push(meta);
      });
      return groups;
    };

    const cardMatches = (card, groups) => {
      if (!groups.size) return true;
      const text = normalize(card.dataset.filterText);

      for (const groupOptions of groups.values()) {
        const groupMatches = groupOptions.some((meta) => {
          if (meta.priceMin !== null || meta.priceMax !== null) {
            const price = Number(card.dataset.productPrice || 0);
            if (meta.priceMin !== null && price < meta.priceMin) return false;
            if (meta.priceMax !== null && price >= meta.priceMax) return false;
            return true;
          }
          if (!meta.terms.length) return true;
          return meta.terms.some((term) => text.includes(term));
        });
        if (!groupMatches) return false;
      }

      return true;
    };

    const updateUrl = () => {
      const url = new URL(window.location.href);
      const groups = selectedByKey();
      ['room', 'type', 'need', 'style', 'price', 'material', 'color', 'size'].forEach((key) => url.searchParams.delete(key));

      groups.forEach((items, key) => {
        url.searchParams.set(key, items.map((item) => item.value).join(','));
      });

      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const renderActiveFilters = () => {
      if (!activeWrap || !activeList) return;
      activeList.replaceChildren();
      activeWrap.hidden = selected.size === 0;

      selected.forEach((meta) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'collection-active-chip';
        chip.dataset.removeFilter = meta.id;
        chip.textContent = `${meta.label} \u00d7`;
        activeList.appendChild(chip);
      });
    };

    const applyFilters = ({ writeUrl = true } = {}) => {
      const groups = selectedByKey();
      let visible = 0;

      grid?.classList.add('is-filtering');

      window.setTimeout(() => {
        cards.forEach((card) => {
          const isVisible = cardMatches(card, groups);
          card.hidden = !isVisible;
          if (isVisible) visible += 1;
        });

        if (count) count.textContent = visible;
        if (empty) empty.hidden = visible !== 0;
        if (pagination) pagination.hidden = selected.size > 0;
        syncButtons();
        renderActiveFilters();
        if (writeUrl) updateUrl();
        grid?.classList.remove('is-filtering');
      }, 120);
    };

    const clearFilters = ({ writeUrl = true } = {}) => {
      selected.clear();
      applyFilters({ writeUrl });
    };

    const restoreFromUrl = () => {
      selected.clear();
      const params = new URL(window.location.href).searchParams;
      optionButtons.forEach((button) => {
        const meta = getOptionMeta(button);
        const values = (params.get(meta.key) || '').split(',').filter(Boolean);
        if (values.includes(meta.value)) selected.set(meta.id, meta);
      });
      applyFilters({ writeUrl: false });
    };

    optionButtons.forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => {
        const meta = getOptionMeta(button);
        if (selected.has(meta.id)) {
          selected.delete(meta.id);
        } else {
          selected.set(meta.id, meta);
        }
        applyFilters();
      });
    });

    presetButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const meta = getOptionMeta(button);
        selected.clear();
        selected.set(meta.id, meta);
        applyFilters();
        page.querySelector('#collection-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    clearPresetButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selected.clear();
        applyFilters();
        if (button.hasAttribute('data-shop-hero-cta')) {
          page.querySelector('#collection-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    page.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-filter]');
      if (removeButton) {
        selected.delete(removeButton.dataset.removeFilter);
        applyFilters();
        return;
      }

      if (event.target.closest('[data-clear-filters]')) {
        clearFilters();
      }
    });

    openDrawer?.addEventListener('click', () => {
      if (!drawer) return;
      drawer.hidden = false;
      window.requestAnimationFrame(() => drawer.classList.add('is-open'));
    });

    closeDrawerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        window.setTimeout(() => {
          drawer.hidden = true;
        }, 220);
      });
    });

    window.addEventListener('popstate', restoreFromUrl);
    restoreFromUrl();
  });

  document.querySelectorAll('[data-wohnideen-hub]').forEach((hub) => {
    const listView = hub.querySelector('[data-wohnideen-list-view]');
    const detailView = hub.querySelector('[data-wohnideen-detail-view]');
    const articles = Array.from(hub.querySelectorAll('[data-wohnideen-article]'));
    const cards = Array.from(hub.querySelectorAll('[data-wohnideen-card]'));
    const categoryButtons = Array.from(hub.querySelectorAll('[data-wohnideen-filter]'));

    const showList = ({ writeUrl = true } = {}) => {
      listView.hidden = false;
      detailView.hidden = true;
      articles.forEach((article) => {
        article.hidden = true;
      });
      if (writeUrl) window.history.pushState({}, '', '/pages/wohnideen');
    };

    const showArticle = (slug, { writeUrl = true } = {}) => {
      const target = articles.find((article) => article.dataset.wohnideenArticle === slug);
      if (!target) {
        showList({ writeUrl: false });
        return;
      }

      listView.hidden = true;
      detailView.hidden = false;
      articles.forEach((article) => {
        article.hidden = article !== target;
      });
      if (writeUrl) window.history.pushState({}, '', `/pages/wohnideen?article=${encodeURIComponent(slug)}`);
      hub.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const restoreWohnideenState = () => {
      const slug = new URL(window.location.href).searchParams.get('article');
      if (slug) {
        showArticle(slug, { writeUrl: false });
      } else {
        showList({ writeUrl: false });
      }
    };

    hub.addEventListener('click', (event) => {
      const openLink = event.target.closest('[data-wohnideen-open]');
      if (openLink) {
        event.preventDefault();
        showArticle(openLink.dataset.wohnideenOpen);
        return;
      }

      if (event.target.closest('[data-wohnideen-back]')) {
        event.preventDefault();
        showList();
      }
    });

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const category = button.dataset.wohnideenFilter;
        categoryButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        cards.forEach((card) => {
          card.hidden = category !== 'alle' && card.dataset.category !== category;
        });
      });
    });

    hub.querySelectorAll('[data-wohnideen-comment-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const message = form.querySelector('[data-comment-message]');
        if (message) message.hidden = false;
        form.reset();
      });
    });

    hub.querySelectorAll('[data-wohnideen-submission-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const message = form.querySelector('[data-submission-message]');
        if (message) message.hidden = false;
        form.reset();
      });
    });

    window.addEventListener('popstate', restoreWohnideenState);
    restoreWohnideenState();
  });
});
